<template>
	<div class="msg-center-container">
		<div class="content-container">
			<BreadCrumb :routerLinks="routerLinks" currentTitle="作品详情"></BreadCrumb>
			<div class="detailsBox">
				<div class="workDetailsBox">
					<div class="browseMode">
						浏览模式：
						<img class="modeIconA" src="../assets/WorkDetails/iconF.png" v-if="modeIndex == 1"
							@click="changeLook(0)" />
						<img class="modeIconA" src="../assets/WorkDetails/iconO.png" v-if="modeIndex == 0" />
						<img class="modeIconB" src="../assets/WorkDetails/iconE.png" v-if="modeIndex == 1" />
						<img class="modeIconB" src="../assets/WorkDetails/iconN.png" v-if="modeIndex == 0"
							@click="changeLook(1)" />
					</div>
					<div class="workDetailsContent">
						<div class="imgListBox">
							<div class="imgList">
								<div class="swiper-container" v-if="modeIndex == 0">
									<div class="swiper-line" style="left: 0;">
									</div>
									<div class="swiper-wrapper">
										<div class="swiper-slide" v-for="(item,index) in banner" :key="index">
											<el-image class="carousel-image" fit="cover" :src="item" :key="item"
												:preview-src-list="banner">
											</el-image>
										</div>
									</div>
									<div class="swiper-line" style="right: 0;">
									</div>
									<div class="swiper-button-prev-official">
										<img class="arrowIcon" src="../assets/WorkDetails/iconD.png" />
									</div>
									<div class="swiper-button-next-official">
										<img class="arrowIcon" src="../assets/WorkDetails/iconC.png" />
									</div>
								</div>
								<div class="swiper-container" v-if="modeIndex == 1">
									<div class="swiper-line" style="left: 0;">
									</div>
									<div class="swiper-wrapper">
										<div class="swiper-slide" v-for="(item,index) in banner" :key="index">
											<div class="four-image">
												<el-image class="four-item" fit="cover" :src="row"
													v-for="(row,rowIndex) in item" :key="rowIndex"
													:preview-src-list="item">
												</el-image>
											</div>
										</div>
									</div>
									<div class="swiper-line" style="right: 0;">
									</div>
									<div class="swiper-button-prev-official">
										<img class="arrowIcon" src="../assets/WorkDetails/iconD.png" />
									</div>
									<div class="swiper-button-next-official">
										<img class="arrowIcon" src="../assets/WorkDetails/iconC.png" />
									</div>
								</div>
							</div>
							<div class="likeAddTo">
								<div class="like" @click="changeLike">
									<img src="../assets/WorkDetails/iconP.png" v-if="goodsInfo.is_zan == 1" />
									<img src="../assets/WorkDetails/iconL.png" v-else />
									点赞
								</div>
								<div class="addTo" @click="changeCollection">
									<img src="../assets/WorkDetails/iconQ.png" v-if="goodsInfo.is_sc == 1" />
									<img src="../assets/WorkDetails/iconM.png" v-else />
									加入心愿单
								</div>
							</div>
						</div>
						<div class="workDetails">
							<div class="title ellipsis-1">{{goodsInfo.title}}</div>
							<div class="desc">
								{{goodsInfo.content}}
							</div>
							<div class="tips">
								<div class="tip" v-if="goodsInfo.cid_name">{{goodsInfo.cid_name}}</div>
								<div class="tip" v-for="(item,index) in goodsInfo.price" :key="index">
									{{item.yongtu}}
								</div>
							</div>
							<div class="purpose">
								用途：
								<el-select v-model="curPurpose.id" class="inputBox" placeholder="请选择用途"
									@change="changePurpose">
									<el-option v-for="item in purposeOpts" :key="item.id" :label="item.yongtu"
										:value="item.id" />
								</el-select>
							</div>
							<div class="basePriceIdentity">
								<div class="basePrice">
									基础售价：<span class="unit">¥</span> <span class="price">{{curPurpose.price}}</span>
								</div>
								<div class="identity">
									可购身份：<span class="level">{{goodsInfo.level ? goodsInfo.level.join(',') : ''}}</span>
								</div>
							</div>
							<div class="baseInfo">
								<div class="infoTitle">作品参数信息</div>
								<div class="baseInfoItem">颜色模式：{{goodsInfo.yanse}}</div>
								<div class="baseInfoItem">尺寸像素：{{goodsInfo.chicun}}</div>
								<div class="baseInfoItem">文件大小：{{goodsInfo.size}}</div>
								<div class="baseInfoItem">文件格式：{{goodsInfo.geshi}} </div>
							</div>
							<div class="copyrightNotice">
								<div class="copyrightNoticeTitle">
									版权说明
								</div>
								<div class="copyrightNoticeDesc">
									{{goodsInfo.banquan}}
								</div>
								<img class="icon" src="../assets/WorkDetails/iconK.png" alt="" />
							</div>
							<div class="remarks">
								<div class="remark" v-for="(item,index) in goodsInfo.label" :key="index">
									<img class="checkIcon" src="../assets/WorkDetails/iconA.png" />
									{{item}}
								</div>
							</div>
							<div class="uploadTime">
								上传时间：{{goodsInfo.create_time}}
							</div>
							<div class="buyNowWant">
								<div class="buyNow" :class="goodsInfo.is_buy == 1 ? 'buyNowAble' :  'buyNowdDisAble'"
									@click="buyWork">立即购买</div>
								<div class="want">
									<img class="wantIcon" src="../assets/WorkDetails/iconB.png" />
									{{goodsInfo.sc_count ? goodsInfo.sc_count : 0}}人想要
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="authorDetails">
					<div class="avatarNameFansWorkNum"
						@click="$router.push({path: '/painter-homepage',query: {id: workerInfo.id}})">
						<img class="avatar" :src="workerInfo.avatar" v-if="workerInfo.avatar" />
						<img class="avatar" src="../assets/defaultAvatar.png" v-else />
						<div class="nameFansWorkNum">
							<div class="name">{{workerInfo.nickname ? workerInfo.nickname : ''}}</div>
							<div class="fansWorkNum">
								<div class="fans">{{workerInfo.fs_count ? workerInfo.fs_count : '0'}}粉丝</div>
								<div class="line"></div>
								<div class="workNum">{{workerInfo.work_count ? workerInfo.work_count : '0'}}作品</div>
							</div>
						</div>
					</div>
					<div class="descTitle">
						画师简介
					</div>
					<div class="desc">
						<div class="descItem">
							在线时间：<div v-html="workerInfo.hs_time ? workerInfo.hs_time.replace(/\n/g, '<br/>') : ''">
							</div>
						</div>
						<div class="descItem">
							偏好类型：<div v-html="workerInfo.hs_ph ? workerInfo.hs_ph.replace(/\n/g, '<br/>') : ''"></div>
						</div>
						<div class="descItem">
							不接类型：<div v-html="workerInfo.hs_bj ? workerInfo.hs_bj.replace(/\n/g, '<br/>') : ''"></div>
						</div>
						<div class="descItem">
							约稿须知： <div v-html="workerInfo.hs_yg ? workerInfo.hs_yg.replace(/\n/g, '<br/>') : ''"></div>
						</div>
					</div>
					<div class="rateBox">
						<div class="rateItem">
							{{workerInfo.zy_count ? workerInfo.zy_count : ''}}
							<div class="rateTitle">需求完成率</div>
						</div>
						<div class="line"></div>
						<div class="rateItem">
							{{workerInfo.zs_count ? workerInfo.zs_count : ''}}
							<div class="rateTitle">准时交稿率</div>
						</div>
						<div class="rateItem">
							{{workerInfo.hp_count ? workerInfo.hp_count : ''}}
							<div class="rateTitle">作品好评率</div>
						</div>
						<div class="line"></div>
						<div class="rateItem">
							<div class="rates" v-if="workerInfo.xj_count">
								<img src="../assets/WorkDetails/iconI.png" v-for="(item,index) in workerInfo.xj_count"
									:key="index" />
								<img src="../assets/WorkDetails/iconJ.png"
									v-for="(item,index) in 3 - workerInfo.xj_count" :key="index + 3" />
							</div>
							<div class="rateTitle">星级画师</div>
						</div>
					</div>
					<div class="menuBox">
						<div class="menuItem" @click="naviToChat(workerInfo)">
							<img src="../assets/WorkDetails/iconH.png" alt="" />
							沟通
						</div>
						<div class="menuItem" @click="huaGuanZhu(workerInfo)">
							<img src="../assets/WorkDetails/iconG.png" alt="" />
							{{workerInfo.is_guanzhu && workerInfo.is_guanzhu == 1 ? '取消关注' : '关注' }}
						</div>
					</div>
				</div>
			</div>
			<!-- 猜你喜欢 -->
			<div class="like-container" v-if="likeData.length > 0">
				<div class="container-title-box">
					<div class="title">
						猜你喜欢
						<div class="subTitle">
							YOU MAY ALSO LIKE
						</div>
					</div>
				</div>
				<div class="likeList">
					<OfficalItem class="officalItem" :routerType="4" :data="item" v-for="(item,index) in likeData"
						:key="index">
					</OfficalItem>
				</div>
				<router-link to="/guess-like" class="view-more-official">
					查看更多 》
				</router-link>
			</div>
		</div>
		<PopToast :imgPtahUrl="require('@/assets/Register/exclaim.png')" :desc="'抱歉，您的身份暂时不满足购买本作品，请仔细核对！'"
			@clickOk="tipPop = false" v-if="tipPop" />
	</div>
</template>
<script>
	import Swiper from 'swiper'
	import 'swiper/css/swiper.css'
	import PopToast from '../components/PopToast.vue'
	import OfficalItem from '../components/OfficalItem.vue'

	export default {
		name: 'WorkDetails',
		components: {
			OfficalItem,
			PopToast
		},
		data() {
			return {
				swiper: null,
				banner: [],
				userInfo: {},
				likeData: [],
				tipPop: false, //判断等级是否可以购买
				goodsInfo: {}, //作品详情
				workerInfo: {}, //画师详情
				curPurpose: {},
				purposeOpts: [], //用途
				modeIndex: 0, //图片浏览模式
				routerLinks: [{
					path: '/creator-flower-market',
					title: '创作者花市',
					query: {}
				}]
			}
		}, //立即购买置灰 需要本地进行身份判断
		watch: {
			$route: {
				handler(to, from) {
					if (to.query.type == 4) {
						this.workerDetal()
						this.goodsWorkDetal()
					}
					console.log('当前路由:', to);
					console.log('之前的路由:', from);
				},
				deep: true, // 深度监听（可选）
				immediate: true // 初始化时立即触发（可选）
			}
		},
		mounted() {
			if (localStorage.getItem('token')) {
				this.userLike()
			}
			if (this.$route.query.type && (this.$route.query.type == 1 || this.$route.query.type == 4)) {
				this.routerLinks = [{
					path: '/creator-flower-market',
					title: '创作者花市',
				}]
			}

			if (this.$route.query.type && this.$route.query.type == 2) {
				this.routerLinks = [{
					path: '/painter-homepage',
					title: '画师主页',
					query: {
						id: this.$route.query.userId
					}
				}]
			}

			if (this.$route.query.type && this.$route.query.type == 3) {
				this.routerLinks = [{
					path: '/personal-center',
					title: '我的心愿单',
					query: {
						menuId: 5
					}
				}]
			}

			if (this.$route.query.type && this.$route.query.type == 5) {
				this.routerLinks = [{
					path: '/',
					title: '首页',
				}]
			}
			this.workerDetal()
			this.goodsWorkDetal()
		},
		methods: {
			initSwiper() {
				if (this.swiper) {
					this.swiper.destroy(true, true)
				}
				// 创建Swiper实例
				this.swiper = new Swiper('.swiper-container', {
					slidesPerView: 'auto',
					centeredSlides: true,
					spaceBetween: 20,
					loop: false,
					autoplay: {
						delay: 5000,
						disableOnInteraction: false
					},
					navigation: {
						nextEl: '.swiper-button-next-official',
						prevEl: '.swiper-button-prev-official',
					},
					effect: 'coverflow',
					coverflowEffect: {
						rotate: 0,
						stretch: 0,
						depth: 100,
						modifier: 3,
						slideShadows: false
					}
				})
			},
			changeLook(index) {
				this.modeIndex = index
				if (this.modeIndex == 0) {
					let bannerAry = []
					this.goodsInfo.banner.forEach(item => {
						bannerAry.push(item)
					})
					this.banner = bannerAry
				} else {
					this.banner = this.goodsInfo.banner.reduce((acc, curr, index) => {
						if (index % 4 === 0) {
							acc.push([curr]);
						} else {
							acc[acc.length - 1].push(curr);
						}
						return acc;
					}, []);
				}
				this.$nextTick(() => {
					this.initSwiper()
				})
			},
			changePurpose(event) {
				this.curPurpose = {
					...this.purposeOpts.find(item => item.id == event)
				}
			},
			//作品详情
			goodsWorkDetal() {
				if (localStorage.getItem('token')) {
					this.$api.post('/Hua/work_detail', {
						id: this.$route.query.id,
						type: 1,
					}).then(res => {
						if (res.code == 1) {
							this.goodsInfo = res.data
							this.banner = res.data.banner
							this.purposeOpts = res.data.price
							this.curPurpose = res.data.price && res.data.price.length > 0 ? {
								...res.data.price[0]
							} : {}
							this.changeLook(this.modeIndex)
						}
					}).catch(err => {
						console.log(err);
					})
					this.$api.post('/UserD/user_details', {}).then(res => {
						if (res.code == 1) {
							this.userInfo = res.data
						}
					}).catch(err => {
						console.log(err);
					})
				} else {
					this.$api.post('/Goods/work_detail', {
						id: this.$route.query.id
					}).then(res => {
						if (res.code == 1) {
							this.goodsInfo = res.data
							this.banner = res.data.banner
							this.purposeOpts = res.data.price
							this.curPurpose = res.data.price && res.data.price.length > 0 ? res.data.price[0] : {}
							this.changeLook(this.modeIndex)
						}
					}).catch(err => {
						console.log(err);
					})
				}
			},
			//画师详情
			workerDetal() {
				if (localStorage.getItem('token')) {
					this.$api.post('/Hua/hua_details', {
						id: this.$route.query.userId
					}).then(res => {
						if (res.code == 1) {
							this.workerInfo = res.data
						}
					}).catch(err => {
						console.log(err);
					})
				} else {
					this.$api.post('/Other/hua_details', {
						id: this.$route.query.userId
					}).then(res => {
						if (res.code == 1) {
							this.workerInfo = res.data
						}
					}).catch(err => {
						console.log(err);
					})
				}
			},
			//沟通
			naviToChat(item) {
				if (localStorage.getItem('token')) {
					this.$router.push(`/personal-center?userId=${item.id}&menuId=3`)
				} else {
					this.$router.replace({
						path: '/login',
					})
				}
			},
			//关注画师
			huaGuanZhu(item) {
				if (localStorage.getItem('token')) {
					this.$api.post('/Hua/guanzhu', {
						mb_id: item.id
					}).then(res => {
						if (res.code == 1) {
							this.$message.success(res.msg)
							this.workerDetal()
						}
					}).catch(err => {
						console.log(err);
					})
				} else {
					this.$router.replace({
						path: '/login',
					})
				}
			},
			changeLike() {
				if (localStorage.getItem('token')) {
					this.$api.post('/Hua/dz_work', {
						id: this.goodsInfo.id
					}).then(res => {
						if (res.code == 1) {
							this.$message.success(res.msg)
							this.goodsWorkDetal()
						}
					}).catch(err => {
						console.log(err);
					})
				} else {
					this.$router.replace({
						path: '/login',
					})
				}
			},
			changeCollection() {
				if (localStorage.getItem('token')) {
					this.$api.post('/Hua/sc_work', {
						id: this.goodsInfo.id
					}).then(res => {
						if (res.code == 1) {
							this.$message.success(res.msg)
							this.goodsWorkDetal()
						}
					}).catch(err => {
						console.log(err);
					})
				} else {
					this.$router.replace({
						path: '/login',
					})
				}
			},
			orderCoupon() {
				this.$api.post('/Order/order_coupon', {
					goods_id: this.$route.query.id,
					yongtu: '8',
					status: '',
				}).then(res => {
					if (res.code == 1) {
						console.log(res.dat)
					}
				}).catch(err => {
					console.log(err);
				})
			},
			userLike() {
				this.$api.post('/Hua/user_like', {}).then(res => {
					if (res.code == 1) {
						this.likeData = res.data.list
					}
				}).catch(err => {
					console.log(err);
				})
			},
			buyWork() {
				if (localStorage.getItem('token')) {
					if (this.goodsInfo.level.indexOf(this.userInfo.level_name) !== -1) {
						if (this.goodsInfo.is_buy == 1) {
							this.$router.push({
								path: '/buy-now',
								query: {
									id: this.goodsInfo.id,
									purpose: this.curPurpose.id,
									userId: this.$route.query.userId,
								}
							})
						}
					} else {
						this.tipPop = true
					}
				} else {
					this.$router.replace({
						path: '/login',
					})
				}
			},
			huaOrder() {
				this.$api.post('/Hua/hua_order', {
					id: this.$route.query.id,
				}).then(res => {
					if (res.code == 1) {
						console.log(res.data)
					}
				}).catch(err => {
					console.log(err);
				})
			},
			huaOrderAdd() {
				this.$api.post('/Hua/hua_order_add', {
					id: this.$route.query.id,
				}).then(res => {
					if (res.code == 1) {
						console.log(res.data)
					}
				}).catch(err => {
					console.log(err);
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.msg-center-container {
		display: flex;
		flex-direction: column;
		align-items: center;
		background: #FDFDF4;
		min-height: 100vh;
	}

	.content-container {
		width: 12rem;
		display: flex;
		flex-direction: column;
	}

	/* Swiper轮播图样式 */
	.swiper-container {
		width: 100%;
		height: 5rem;
		overflow: hidden;
	}

	.swiper-line {
		width: 0.12rem;
		position: absolute;
		top: 0;
		height: 100%;
		background: #FFFFFF;
		z-index: 4;
	}

	.swiper-slide {
		position: relative;
		width: 100%;
		height: 100%;
		transform: scale(1) !important;
		padding: 0 .12rem;
	}

	.carousel-image {
		width: 100%;
		height: 100%;
		border-radius: .12rem;
		overflow: hidden;
		object-fit: cover;
	}

	.four-image {
		width: 100%;
		height: 100%;
		border-radius: .12rem;
		background: #FFFFFF;
		overflow: hidden;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;

		.four-item {
			margin-top: .12rem;
			width: 1.7rem;
			height: 2.28rem;
			border-radius: .08rem;
			overflow: hidden;
			object-fit: cover;
		}
	}

	/* 导航箭头样式 */
	.swiper-button-prev-official,
	.swiper-button-next-official {
		position: absolute;
		top: 0%;
		width: .24rem;
		height: 100%;
		display: flex;
		align-items: center;
		z-index: 5;

		.arrowIcon {
			width: .24rem;
			height: .24rem;
			cursor: pointer;
		}
	}

	.swiper-button-prev-official {
		left: 0%;
		justify-content: flex-start;
	}

	.swiper-button-next-official {
		right: 0%;
		justify-content: flex-end;
	}

	.detailsBox {
		margin-top: .2rem;
		display: flex;
		justify-content: space-between;

		.workDetailsBox {
			display: flex;
			flex-direction: column;
			width: 9rem;
			background: #FFFFFF;
			box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
			border-radius: .12rem;
			padding: .24rem .32rem .32rem .14rem;

			.browseMode {
				display: flex;
				align-items: center;
				font-weight: 400;
				font-size: .14rem;
				color: #333333;

				.modeIconA {
					margin-left: .16rem;
					margin-right: .12rem;
					width: .2rem;
					height: .16rem;
					cursor: pointer;
				}

				.modeIconB {
					width: .16rem;
					height: .16rem;
					cursor: pointer;
				}
			}

			.workDetailsContent {
				display: flex;
				justify-content: space-between;
				margin-top: .08rem;

				.imgListBox {
					display: flex;
					flex-direction: column;

					.imgList {
						width: 4rem;
						height: 5rem;
						border-radius: .08rem;
					}

					.likeAddTo {
						margin: .24rem auto;
						display: flex;
						align-items: center;

						.like,
						.addTo {
							margin: 0 .16rem;
							display: flex;
							align-items: center;
							justify-content: center;
							border-radius: .04rem;
							font-weight: 400;
							font-size: .14rem;
							color: #333333;
							width: 1.16rem;
							height: .38rem;
							border: .01rem solid #CCCCCC;
							cursor: pointer;

							img {
								width: .18rem;
								height: .18rem;
								margin-right: .06rem;
							}
						}
					}
				}

				.workDetails {
					display: flex;
					flex-direction: column;

					.title {
						font-weight: 700;
						font-size: .24rem;
						color: #000000;
						line-height: .32rem;
					}

					.desc {
						margin-top: .08rem;
						width: 4.45rem;
						font-weight: 400;
						font-size: .14rem;
						color: #333333;
						line-height: .2rem;
					}

					.tips {
						margin-top: .12rem;
						display: flex;
						align-items: center;

						.tip {
							margin-right: .1rem;
							height: .26rem;
							padding: 0 .08rem;
							border-radius: .13rem;
							border: .01rem solid #A88653;
							font-weight: 400;
							font-size: .12rem;
							color: #7C3E0B;
							line-height: .26rem;
						}
					}

					.purpose {
						margin-top: .16rem;
						display: flex;
						align-items: center;
						font-size: .14rem;
						color: #333333;

						::v-deep .el-input {

							&__inner {
								width: 2.5rem;
								height: .4rem;
								font-weight: 400;
								font-size: .14rem;
								color: #252525;
								line-height: .4rem;
								border: .01rem solid #EFD8B8;
							}

							&__icon {
								font-size: .14rem;
								line-height: .4rem;
							}
						}
					}

					.basePriceIdentity {
						margin-top: .08rem;
						display: flex;
						align-items: baseline;

						.basePrice {
							display: flex;
							align-items: baseline;
							font-weight: 400;
							font-size: .14rem;
							color: #333333;

							.unit {
								color: #FF0100;
							}

							.price {
								font-weight: 700;
								font-size: .24rem;
								color: #FF0100;
							}
						}
					}

					.identity {
						margin-left: .24rem;
						display: flex;
						align-items: center;
						font-weight: 400;
						font-size: .14rem;
						color: #333333;

						.level {
							color: #AF9062;
						}
					}

					.baseInfo {
						margin-top: .16rem;
						display: flex;
						flex-direction: column;
						width: 4.45rem;
						padding: .12rem .16rem;
						background: #FAEFDD;
						border-radius: .06rem;

						.infoTitle {
							font-weight: 700;
							font-size: .14rem;
							color: #333333;
							line-height: .22rem;
						}

						.baseInfoItem {
							margin-top: .06rem;
							font-weight: 400;
							font-size: .14rem;
							color: #333333;
							line-height: .22rem;
						}
					}

					.copyrightNotice {
						margin-top: .12rem;
						display: flex;
						flex-direction: column;
						width: 4.45rem;
						background: #693200;
						padding: .12rem .16rem;
						border-radius: .06rem;
						position: relative;

						.copyrightNoticeTitle {
							font-weight: 700;
							font-size: .14rem;
							color: #FFFFFF;
							line-height: .22rem;
						}

						.copyrightNoticeDesc {
							width: 3.2rem;
							font-weight: 400;
							font-size: .14rem;
							color: #FFFFFF;
							line-height: .22rem;
						}

						.icon {
							position: absolute;
							width: .42rem;
							height: .5rem;
							top: .12rem;
							right: .2rem;
						}
					}

					.remarks {
						margin-top: .16rem;
						display: flex;
						align-items: center;

						.remark {
							margin-right: .24rem;
							display: flex;
							align-items: center;
							font-weight: 400;
							font-size: .12rem;
							color: #B19365;
							line-height: 18px;

							.checkIcon {
								margin-right: .04rem;
								width: .14rem;
								height: .14rem;
							}
						}
					}

					.uploadTime {
						margin-top: .16rem;
						font-weight: 400;
						font-size: .12rem;
						color: #666666;
						line-height: .22rem;
					}

					.buyNowWant {
						margin-top: .16rem;
						display: flex;
						align-items: center;

						.buyNow {
							width: 2.60rem;
							height: .52rem;
							border-radius: .06rem;
							font-weight: 500;
							font-size: .15rem;
							color: #252525;
							line-height: .52rem;
							text-align: center;
							cursor: pointer;
						}

						.buyNowAble {
							background: #E29358;
						}

						.buyNowdDisAble {
							background: #CCCCCC;
						}

						.want {
							margin-left: .32rem;
							display: flex;
							align-items: center;
							font-size: .14rem;
							color: #999999;

							.wantIcon {
								margin-right: .16rem;
								width: .52rem;
								height: .52rem;
							}
						}
					}
				}
			}
		}

		.authorDetails {
			display: flex;
			align-self: self-start;
			flex-direction: column;
			width: 2.85rem;
			background: #FFFFFF;
			padding: .24rem .16rem .32rem;
			box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
			border-radius: .12rem;

			.avatarNameFansWorkNum {
				display: flex;
				align-items: center;
				cursor: pointer;

				.avatar {
					width: .5rem;
					height: .5rem;
					border-radius: 50%;
					overflow: hidden;
					object-fit: cover;
				}

				.nameFansWorkNum {
					margin-left: .12rem;
					display: flex;
					flex-direction: column;

					.name {
						font-weight: 500;
						font-size: .16rem;
						color: #312C28;
					}

					.fansWorkNum {
						margin-top: .04rem;
						display: flex;
						align-items: center;
						font-weight: 400;
						font-size: .12rem;
						color: #666666;

						.line {
							margin: 0 .08rem;
							width: .02rem;
							height: .08rem;
							background: #CCCCCC;
						}
					}
				}
			}

			.descTitle {
				margin-top: .16rem;
				font-weight: 500;
				font-size: .14rem;
				color: #1C1C1C;
				line-height: .2rem;
			}

			.desc {
				// margin-top: .12rem;
				// font-weight: 400;
				// font-size: .12rem;
				// color: #666666;
				// line-height: .18rem;

				margin-top: .08rem;
				width: 4.45rem;
				// font-weight: 400;
				// font-size: .14rem;
				// color: #333333;
				// line-height: .2rem;
				display: flex;
				flex-direction: column;

				.descItem {
					width: 100%;
					display: flex;
					align-items: flex-start;
					font-weight: 400;
					font-size: .14rem;
					color: #333333;
					line-height: .2rem;

					div {
						width: 1.85rem;
					}
				}
			}

			.rateBox {
				margin-top: .16rem;
				display: flex;
				flex-wrap: wrap;
				align-items: center;
				padding: 0 0 .16rem;
				border-top: 0.01rem solid #CCCCCC;
				border-bottom: 0.01rem solid #CCCCCC;

				.rateItem:last-child {
					.rateTitle {
						margin-top: .16rem;
					}
				}

				.rateItem {
					margin-top: .16rem;
					width: calc(50% - .01rem);
					display: flex;
					flex-direction: column;
					align-items: center;
					font-weight: bold;
					font-size: .26rem;
					color: #E29358;

					.rateTitle {
						margin-top: .06rem;
						font-weight: 400;
						font-size: .12rem;
						color: #1C1C1C;
					}

					.rates {
						margin-top: .15rem;
						display: flex;
						align-items: center;

						img {
							margin-right: .06rem;
							width: .15rem;
							height: .15rem;
						}
					}
				}

				.line {
					width: .02rem;
					height: .4rem;
					background: #CCCCCC;
				}
			}

			.menuBox {
				margin-top: .08rem;
				display: flex;
				flex-direction: column;

				.menuItem {
					margin: .16rem auto 0;
					width: 2.2rem;
					height: .38rem;
					display: flex;
					align-items: center;
					justify-content: center;
					box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
					border-radius: .06rem;
					font-weight: 400;
					font-size: .14rem;
					color: #FFFFFF;
					cursor: pointer;

					img {
						margin-right: .04rem;
						width: .14rem;
						height: .14rem;
					}
				}

				.menuItem:first-child {
					background: #706614;
				}

				.menuItem:last-child {
					background: #E29358;
				}
			}
		}
	}

	li {
		font-size: .14rem !important;
		margin-bottom: 0;
	}

	.like-container {
		width: 100%;
		height: 15.2rem;
		background: #FDFDF4;
		display: flex;
		flex-direction: column;
		align-items: center;

		.container-title-box {
			margin: 1rem auto 0;
			display: flex;
			text-align: center;
			justify-content: center;

			&::before {
				content: '';
				display: inline-block;
				margin-top: .3rem;
				margin-right: .12rem;
				width: 1.65rem;
				height: 0;
				border-top: .01rem dashed #706614;
				opacity: 0.3;
			}

			&::after {
				content: '';
				display: inline-block;
				margin-top: .3rem;
				margin-left: .12rem;
				width: 1.65rem;
				height: 0;
				border-top: .01rem dashed #706614;
				opacity: 0.3;
			}

			.title {
				font-weight: 700;
				font-size: .4rem;
				color: #7C400E;

				.subTitle {
					font-weight: 400;
					font-size: .14rem;
					color: #7C400E;
				}
			}
		}

		.likeList {
			margin-top: .28rem;
			width: 12rem;
			display: flex;
			flex-wrap: wrap;

			.officalItem:nth-child(4n) {
				margin-right: 0;
			}
		}

		.view-more-official {
			margin: .6rem auto;
			font-weight: 400;
			font-size: .16rem;
			color: #A88653;
		}
	}
</style>